const drawerWidth = 240;

module.exports = {
    drawerWidth: drawerWidth
}